export default "__VITE_ASSET__7bd6b947__"